var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"quantity-graph-container",attrs:{"wxid":_vm.$options.name}},[_c('figure',[(_vm.isDataReady())?_c('wx-chart-bar-graph',{attrs:{"chart-data":_vm.getChartData(),"chart-options":_vm.getChartOptions(),"css-classes":"canvas-container"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }